function RecommendationSourceToString(source) {
    switch (source) {
        case 1 : return 'file';
        case 2 : return 'workspace';
        case 3 : return 'exe';
    }
}

export { RecommendationSourceToString };
